/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-action-18" size="18" style="display: none;">
<svg>
  <defs>
    <g id="star">
      <path d="M14.557 18.017l-5.56-4.213-5.56 4.213 2.087-6.87L0 6.882l6.85-.03L9 0l2.144 6.85 6.852.033-5.524 4.266 2.087 6.867z"></path>
    </g>
  </defs>
</svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
